import {
  Actions,
  DELETE_MYACCOUNT_ACTION_FAIL,
  DELETE_MYACCOUNT_ACTION_SUCCESS,
  RESET,
  SEND_TEMPLATED_EMAIL_ACTION_FAIL,
  SEND_TEMPLATED_EMAIL_ACTION_SUCCESS,
  UNENROLL_USER_FAIL,
  UNENROLL_USER_SUCCESS
} from './delete-myaccount.action';
import { DeleteMyAccount, DeleteMyAccountStatus, initialState } from './delete-myaccount.model';

const resolveStatusCode = (status: DeleteMyAccountStatus): number | null =>
  typeof status === 'object' ? (status.code ?? null) : status;

export function deleteMyAccountReducer(state = initialState, action: Actions): DeleteMyAccount {
  switch (action.type) {
    case RESET:
      return {
        ...state,
        unenrollProgramsStatus: null,
        deleteMyAccountStatus: null,
        sendTemplatedEmailStatus: null
      };

    case UNENROLL_USER_FAIL:
    case UNENROLL_USER_SUCCESS:
      return {
        ...state,
        unenrollProgramsStatus: resolveStatusCode(action.payload.status)
      };

    case DELETE_MYACCOUNT_ACTION_SUCCESS:
    case DELETE_MYACCOUNT_ACTION_FAIL:
      return { ...state, deleteMyAccountStatus: resolveStatusCode(action.payload.status) };

    case SEND_TEMPLATED_EMAIL_ACTION_SUCCESS:
    case SEND_TEMPLATED_EMAIL_ACTION_FAIL:
      return { ...state, sendTemplatedEmailStatus: resolveStatusCode(action.payload.status) };

    default:
      return state;
  }
}

export const unenrollProgramsStatus = (state: DeleteMyAccount) => state.unenrollProgramsStatus;
export const deleteMyAccountStatus = (state: DeleteMyAccount) => state.deleteMyAccountStatus;
export const sendTemplatedEmailStatus = (state: DeleteMyAccount) => state.sendTemplatedEmailStatus;
